import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import LazyLoad from 'react-lazyload';
import LoaderAnimated from '../../abstract/loaders/loaderAnimated';

const launcherProductReviewFeed = () => {
  const tmbProductReviewFeedWidgets = document.getElementsByClassName('tmb-product-review-feed-widget');
  let i;
  for (i = 0; i < tmbProductReviewFeedWidgets.length; i++) {
    const tmbProductReviewFeedWidget = tmbProductReviewFeedWidgets[i];
    if(tmbProductReviewFeedWidget){
      const productId = tmbProductReviewFeedWidget.dataset.productid;
      const apiKey = tmbProductReviewFeedWidget.dataset.apikey;
      const defaultSort = tmbProductReviewFeedWidget.dataset.defaultsort || 'latest'; // latest | highest
      const ProductWidget = React.lazy(() => import('../../widgets/productReviewFeed/productReviewFeedWidget'));
      ReactDOM.render(
        <LazyLoad once offset={300}>
          <Suspense fallback={<LoaderAnimated animated={false} maxWidth="515px" height="193px" />}>
            <ProductWidget productId={productId} apiKey={apiKey} defaultSort={defaultSort} /> 
          </Suspense>
        </LazyLoad>
      , tmbProductReviewFeedWidget);
    }
  }
};

export default launcherProductReviewFeed;